import React, { useEffect } from "react";
import { useRecoilState } from 'recoil';
import PropTypes from "prop-types";
import {
	baseLatState,
	baseLngState,
	baseIdState,
	effectiveUtilizationState,
	googleApiKeyState,
	timezoneState,
	urlItinerariesState,
	userIDState,
} from "../recoil/atoms"
import Gmaps from "./Gmaps";
import Calendar from "./Calendar";
import CalendarResource from "./CalendarResource";

const RouteAppSchedule = ( { props } ) => {
	const [ googleApiKey, setGoogleApiKey ] = useRecoilState( googleApiKeyState );
	const [ baseLng, setBaseLng ] = useRecoilState( baseLngState );
	const [ baseLat, setBaseLat ] = useRecoilState( baseLatState );
	const [ basePlaceId, setBasePlaceId ] = useRecoilState( baseIdState );
	const [ effectiveUtilization, setEffectiveUtilization ] = useRecoilState( effectiveUtilizationState );
	const [ timezone, setTimezone ] = useRecoilState( timezoneState );
	const [ urlItineraries, setUrlItineraries] = useRecoilState( urlItinerariesState );

	useEffect( () => {
		setBaseLat( props.baseLat );
		setBaseLng( props.baseLng );
		setBasePlaceId( props.basePlaceId );
		setGoogleApiKey( props.googleApiKey );
		setEffectiveUtilization( props.effectiveUtilization );
		setTimezone( props.timezone );
		setUrlItineraries( props.url );
	}, [ props ] )

	return (
		<React.Fragment>
			<div className="row" style={{height: "750px", marginBottom: "15px"}}>
				<div className="col-xl-7">
					<CalendarResource />
				</div>
				<div className="col-xl-5 map-container">
					<Gmaps />
				</div>
			</div>
		</React.Fragment>
	)
};
RouteAppSchedule.propTypes = {
	greeting: PropTypes.string,
	baseLat: PropTypes.string,
	baseLng: PropTypes.string,
	basePlaceId: PropTypes.string,
	googleApiKey: PropTypes.string,
	effectiveUtilization: PropTypes.number,
	timezone: PropTypes.string,
	urlItineraries: PropTypes.string,
};


export default RouteAppSchedule;
